import { getUserInfo, login, logout, normalizeLoginResult } from '@/api/user'
import { getToken, removeRefreshToken, removeToken, setRefreshToken, setToken } from '@/utils/auth'
import { clearStoreId } from '@/utils/business-context'

function initialState() {
  return {
    token: getToken(),
    userInfo: null,
    roles: []
  }
}

const state = initialState()

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    state.roles = (userInfo && userInfo.roles) || []
  },
  RESET_STATE(state) {
    Object.assign(state, initialState(), { token: '', userInfo: null, roles: [] })
  }
}

const actions = {
  login({ commit }, form) {
    return login(form).then(data => {
      setToken(data.token)
      setRefreshToken(data.refreshToken)
      commit('SET_TOKEN', data.token)
      if (data.user) commit('SET_USER_INFO', data.user)
      return data
    })
  },
  completeLogin({ commit }, result) {
    const data = normalizeLoginResult(result)
    setToken(data.token)
    setRefreshToken(data.refreshToken)
    commit('SET_TOKEN', data.token)
    commit('SET_USER_INFO', data.user)
    return data
  },
  getInfo({ commit }) {
    return getUserInfo().then(data => {
      commit('SET_USER_INFO', data)
      return data
    })
  },
  logout({ commit }) {
    return logout().catch(() => null).finally(() => {
      removeToken()
      removeRefreshToken()
      clearStoreId()
      commit('RESET_STATE')
    })
  },
  resetToken({ commit }) {
    removeToken()
    removeRefreshToken()
    clearStoreId()
    commit('RESET_STATE')
    return Promise.resolve()
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
